module.exports = __webpack_public_path__ + "img/name_on.e262e5ce.png";